import React from "react";
import {Routes, Route} from "react-router-dom";
import {ThemeProvider} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import "./App.css";
import theme from "./styles/theme";

import HomePage from "./pages/HomePage";
import LoginPage from "./pages/auth/LoginPage";
import DashboardGuard from "./pages/dashboard/DashboardGuard";
import DashboardEmployees from "./pages/dashboard/DashboardEmployees";
import AccountRequestForm from "./pages/auth/AccountRequestForm";
import ForgotPassword from "./pages/auth/ForgotPassword";
import DashboardEvvPage from "./pages/dashboard/DashboardEvvPage";
import Four04Page from "./pages/Four04Page";
import AuthGuard from "./context/AuthGuard";
import ReLoginGuard from "./context/ReLoginGuard";
import DashboardStaff from "./pages/dashboard/DashboardStaff";
import AccountPage from "./pages/account/AccountPage";
import AccountForm from "./components/account/AccountForm";
import AccountPasswordForm from "./components/account/AccountPasswordForm";
import DbEmpDetailsPage from "./pages/dashboard/DbEmpDetailsPage";

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline/>
            <Routes>
                <Route path="*" element={<Four04Page/>}/>
                <Route path="/" element={<AuthGuard/>}>
                    <Route path="account" element={<AccountPage />}>
                        <Route path="change-password" element={<AccountPasswordForm />} />
                        <Route index element={<AccountForm />} />
                    </Route>
                    <Route index element={<HomePage/>}/>
                </Route>
                <Route path="dashboard" element={<DashboardGuard/>}>
                    <Route path="evv" element={<DashboardEvvPage/>}/>
                    <Route path="staff" element={<DashboardStaff/>}/>
                    <Route path="employees" element={<DashboardEmployees/>}/>
                    <Route path="employees/:empId" element={<DbEmpDetailsPage/>}/>
                    <Route index element={<DashboardEvvPage/>}/>
                </Route>
                <Route path={"auth"} element={<ReLoginGuard/>}>
                    <Route path="login" element={<LoginPage/>}/>
                    <Route path="forgot-password" element={<ForgotPassword/>}/>
                    <Route path="account-signup" element={<AccountRequestForm/>}/>
                    <Route index element={<LoginPage/>}/>
                </Route>
            </Routes>
        </ThemeProvider>
    );
}

export default App;
